// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__2d92u","list":"styles_list__1o5ke"};